import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SSOService, newPartnerServiceContext } from '@vendasta/sso';
import { firstValueFrom, map } from 'rxjs';
import { devServer, partnerId } from '../globals';
import { showAuthDialog } from './auth-wall/auth-wall-dialog.component';
import { AuthService } from './auth.service';

export const AuthGuard = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (Capacitor.isNativePlatform()) {
    try {
      await authService.refreshAccessToken();
    } catch {
      router.navigate(['/landing']);
      return false;
    }
  }

  if (!authService.isAuthed()) {
    if (Capacitor.isNativePlatform()) {
      // Should capture the next URL here and redirect to it after auth
      router.navigate(['/landing']);
    } else if (devServer) {
      const s = showAuthDialog();
      const ref = s();
      firstValueFrom(ref.afterClosed()).then(() => {
        router.navigate([state.url]);
      });
    } else {
      const ssoService = inject(SSOService);
      ssoService
        .getSessionTransferURL('VBC', newPartnerServiceContext(partnerId))
        .pipe(map((resp) => resp.sessionTransferUrl))
        .subscribe((url) => {
          router.navigateByUrl(url);
        });
    }
    return false;
  }
  return true;
};
